import {Observer, observer} from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {WordMask} from "./WordMask";
import {MasksComponent, MasksQuery, MasksQueryResult, WordMaskObject} from "../../types.d";
import {observable} from "mobx";
import {autobind} from "core-decorators";

export interface IWordMasksController {
    data?: MasksQuery
}

interface WordMasksProps {
    courseId: number;
    rank: number;
    onSelect?: (word: WordMaskObject) => any;
    onReady: (ref) => any;
}

export class WordMasksController implements IWordMasksController {

    @observable highlightedWords = [];

    constructor(public data: MasksQuery) {
    }

    get allWords(): WordMaskObject[] {
        return (Object.values(this.data) as WordMaskObject[][])
            .reduceRight((prev: WordMaskObject[], current: WordMaskObject[]) => {
                return [...prev, ...current];
            }, []);
    }

}

@observer export class WordMasks extends Component<WordMasksProps, any> {

    ref: HTMLInputElement;
    @observable searchFilter = '';
    @observable maskController: WordMasksController;

    @autobind _renderMasks(result: MasksQueryResult) {
        if (result.data) {
            const { adjectives, nouns, verbs, other } = result.data;

            return <>
                <Observer>
                    { () => (
                        <div className="search_words_maskes column-count-4 appendto-dest-1 input-dest-1">
                            { [
                                { value: nouns, title: 'Nouns' },
                                { value: adjectives, title: 'Adjectives' },
                                { value: verbs, title: 'Verbs' },
                                { value: other, title: 'Other' },
                            ].map((result, index) => (
                                <WordMask
                                    onSelect={this.props.onSelect}
                                    controller={this.maskController}
                                    filter={this.searchFilter}
                                    words={result.value}
                                    key={index}
                                    title={result.title} />
                            )) }
                        </div>
                    ) }
                </Observer>

                <div className="search-field appendto-dest-1" style={{ maxWidth: 340 }}>
                    <div className="input-group mb-3">
                        <input type="search"
                               className="form-control"
                               ref={e => this.ref = e}
                               onChange={e => {
                                   this.searchFilter = e.currentTarget.value;
                               }}
                               onKeyDown={e => {
                                   if (e.key === 'Enter' && this.searchFilter.length) {
                                       const filteredWords = this.maskController.allWords
                                           .filter(value => value.word.toLowerCase().includes(this.searchFilter.toLowerCase()));

                                       if (filteredWords.length === 1) {
                                           this.props.onSelect(filteredWords[0]);
                                           this.searchFilter = '';
                                           this.ref.value = '';
                                       }
                                   }
                               }}
                               placeholder="Search..."
                               aria-label="Search"
                               aria-describedby="basic-addon2" />
                    </div>
                </div>
            </>;
        }

        return null;
    }

    render() {
        return <>
            <MasksComponent
                onCompleted={data => {
                    this.maskController = new WordMasksController(data);
                    this.props.onReady(this.maskController);
                }}
                variables={{
                    courseId: this.props.courseId,
                    rank: this.props.rank
                }}
            >
                {this._renderMasks}
            </MasksComponent>
        </>
    }

}
